import axios from '../../http_v2'
export default {
  add: (params) => {
    return axios.post('activityservice/screenmanage/insert', params)
  },
  update: (params) => {
    return axios.post('activityservice/screenmanage/update', params)
  },
  del: (params) => {
    return axios.post('activityservice/screenmanage/delete', params)
  },
  list: (params) => {
    return axios.post('activityservice/screenmanage/list', params)
  },

  setting: {
    //基本设置
    basic: {
      get: (params) => {
        return axios.post('activityservice/screenbasicsetup/query', params)
      },
      update: (params) => {
        return axios.post('activityservice/screenbasicsetup/update', params)
      }
    },
    //模板设置
    template: {
      list: 'activityservice/templatesetup/list', //获取模板设置
      inset: 'activityservice/templatesetup/insert', //新增模板设置
      update: 'activityservice/templatesetup/update', //修改模板设置
      delete: 'activityservice/templatesetup/delete' //删除模板设置
    },
    //弹幕设置
    barrage: {
      list: 'activityservice/bulletscreen/list', //获取弹幕设置
      insert: 'activityservice/bulletscreen/insert', //新增弹幕设置
      update: 'activityservice/bulletscreen/update', //修改弹幕设置
      delete: 'activityservice/bulletscreen/delete', //删除弹幕设置
    }
  },

  //抽奖模块
  prize: {
    prizeSavefile: 'mprizeservice/prize/savefile',
    add: (params) => {
      return axios.post('mprizeservice/prize/save', params)
    },
    update: (params) => {
      return axios.post('mprizeservice/prize/update', params)
    },
    del: (params) => {
      return axios.post('mprizeservice/prize/delete', params)
    },
    get: (params) => {
      return axios.post('mprizeservice/prize/findone', params)
    },
    list: (params) => {
      return axios.post('mprizeservice/prize/list', params)
    },
    person: (params) => {
      return axios.post('mprizeservice/winninglist/page', params)
    },
    delPerson: (params) => {
      return axios.post('mprizeservice/winninglist/deleteone', params)
    },
    exportPerson: (params) => {
      return axios.post('mprizeservice/winninglist/page/export', params)
    },
    winningListSavewinners: 'mprizeservice/winninglist/savewinners', //保存中奖人员名单
    winningListDelete: 'mprizeservice/winninglist/delete', //删除奖项下的中奖人员名单
  },

  //用户模块
  person: {
    add: (params) => {
      return axios.post('activityservice/rostersetup/insert', params)
    },
    update: (params) => {
      return axios.post('activityservice/rostersetup/update', params)
    },
    updateAll: (params) => {
      return axios.post('activityservice/rostersetup/batchupdate', params)
    },
    del: (params) => {
      return axios.post('activityservice/rostersetup/delete', params)
    },
    delAll: (params) => {
      return axios.post('activityservice/rostersetup/batchdelete', params)
    },
    list: (params) => {
      return axios.post('activityservice/rostersetup/list', params)
    },
    importActivePerson:  (params) => {
      return axios.get('activityservice/rostersetup/synchron', params)
    }
  },

  //消息模块
  message: {
    page: 'message/message/page', //获取消息
    delete: 'message/message/delete', //删除消息
    chatset: 'message/messageset/chatset', //弹幕设置“是否启用聊天设置”+弹幕设置“是否开启评论审核
    onthewallset: 'message/message/update', //更改消息为上墙和未上墙,0代表上1代表不上
    auditset: 'message/message/audit', //更改改消息为是否审核状态,0代表未审核,1代表已审核
    export: 'message/message/export', //导出消息数据
    getset: 'message/messageset/get',
  }

}
